var logging = false;

var customLogger = function customLogger() {};

var setLogging = function setLogging(_logging) {
  logging = _logging;
};

var setCustomLogger = function setCustomLogger(logger) {
  customLogger = logger;
};

var log = function log(type, message) {
  customLogger({
    type: type,
    message: message
  });

  if (logging) {
    console.log("[".concat(type, "] ").concat(message));
  }
};

module.exports = {
  logging: logging,
  setLogging: setLogging,
  setCustomLogger: setCustomLogger,
  log: log
};